__turbopack_context__.v({
  "interactiveMap": "InteractiveMap-module-scss-module__3Jnwha__interactiveMap",
});
